import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-24 md:py-32 bg-[#faf9f7]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://y-f-s.jp/img/main1.jpeg"
                alt="代表挨拶"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-5 shadow-sm max-w-[200px]">
              <div className="text-3xl font-bold text-[#1a2332]">7年+</div>
              <div className="text-xs text-gray-500 mt-1">コンサルティング実績</div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">About Us</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mt-3 mb-6">
              実務に基づく<br />コンサルティング
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-6">
              株式会社Y・F・Sは、中小企業および個人事業主を対象に、
              Web集客および営業支援を中心としたコンサルティングサービスを提供しております。
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              市場環境の変化に対応しながら、「安定した集客」と「再現性のある営業体制」を構築することで、
              企業の持続的な成長に貢献することを目的としています。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
              {[
                { icon: 'ri-shield-check-line', label: '実務ベースの提案' },
                { icon: 'ri-links-line', label: '一貫した支援体制' },
                { icon: 'ri-building-line', label: '中小企業に特化' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1a2332]/10">
                    <i className={`${item.icon} text-[#1a2332]`} />
                  </div>
                  <span className="text-sm font-medium text-[#1a2332]">{item.label}</span>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#1a2332] text-white text-sm font-medium rounded-lg hover:bg-[#2d3748] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              会社概要を見る <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
